import React from "react";
import { Col, Row, Image } from "react-bootstrap";
import maerskLogo from "./assets/images/maersk_logo.png";
import sharepoint from "./assets/images/sharepoint.png";
import { FaYammer } from "react-icons/fa";
import { Link } from "react-router-dom";
import {
  AZURE_DEVOPS_data_Form_prod,
  AZURE_DEVOPS_data_Form_dev,
  INFRA_STRUCTURE_data_Form_dev,
  INFRA_STRUCTURE_data_Form_prod,
  CENTRAL_METASTORE_data_Form_dev,
  CENTRAL_METASTORE_data_Form_prod,
  DATA_ACCESSAPI_data_Form_dev,
  DATA_ACCESSAPI_data_Form_prod,
  // DATA_LAKE_data_Form_dev,
  // DATA_LAKE_data_Form_prod,
} from "../../App/Constants/MSformsUrlConstants";

const FooterComponent = () => {
  const footerText = {
    color: "#cccccc",
    textAlign: "center",
    outline: "none",
  };

  const footerHeading = {
    color: "#cccccc",
    fontWeight: "bold",
    fontSize: "20px",
  };

  let AzureDevops =
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_RUN_ENV === "production"
      ? AZURE_DEVOPS_data_Form_prod
      : AZURE_DEVOPS_data_Form_dev;
  let InfraStructure =
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_RUN_ENV === "production"
      ? INFRA_STRUCTURE_data_Form_prod
      : INFRA_STRUCTURE_data_Form_dev;
  let CentralMetastore =
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_RUN_ENV === "production"
      ? CENTRAL_METASTORE_data_Form_prod
      : CENTRAL_METASTORE_data_Form_dev;
  let DataAccessapi =
    process.env.NODE_ENV === "production" &&
    process.env.REACT_APP_RUN_ENV === "production"
      ? DATA_ACCESSAPI_data_Form_prod
      : DATA_ACCESSAPI_data_Form_dev;
  // let DataLake =
  // 	process.env.NODE_ENV === "production" &&
  // 	process.env.REACT_APP_RUN_ENV === "production"
  // 		? DATA_LAKE_data_Form_prod
  // 		: DATA_LAKE_data_Form_dev;

  const today = new Date();

  return (
    <div style={{ width: "100% !important" }}>
      <footer
        className="fixed-bottom"
        style={{
          textAlign: "center",
          bottom: "0",
          position: "static",
          paddingTop: "30px",
          float: "center",
          width: "100%",
          backgroundColor: "#4d4d4d",
        }}
      >
        <div className="container">
          <Col sm={3} md={12} style={{ textAlign: "center", width: "100%" }}>
            <Row>
              <Col className="col-sm-3">
                <nav className="footer-menu">
                  <h1 style={footerHeading}>
                    Contact Maestro Platform Capability Team
                  </h1>

                  <ul>
                    <br />
                    <li>
                      <a
                        style={footerText}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={AzureDevops}
                        title="Raise request for AzureDevops"
                      >
                        AzureDevops
                      </a>
                    </li>
                    <br />
                    <li>
                      <a
                        style={footerText}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={InfraStructure}
                        title="Raise request for Infrastructure"
                      >
                        Infrastructure
                      </a>
                    </li>
                    <br />
                    <li>
                      <a
                        style={footerText}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={CentralMetastore}
                        title="Raise request for Centeral Meta Store"
                      >
                        Central Meta Store
                      </a>
                    </li>
                    <br />
                    <li>
                      <a
                        style={footerText}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={DataAccessapi}
                        title="Raise request for Data Access API"
                      >
                        Data Access API
                      </a>
                    </li>
                    <br />
                  </ul>
                </nav>
              </Col>

              {/* <Col className="col-sm-3">
                <nav className="footer-menu">
                  <h2 style={footerHeading}>Contact Maestro Data Lake</h2>
                  <ul>
                    <br />
                    <li>
                      <a
                        style={footerText}
                        target="_blank"
                        rel="noopener noreferrer"
                        href={DataLake}
                        title="Raise request for Data Lake services"
                      >
                        Azure Data Lake
                      </a>
                    </li>
                    <br />
                  </ul>
                </nav>
              </Col> */}

              <Col className="col-sm-3">
                <nav className="footer-menu">
                  <h2 style={footerHeading}>Docs</h2>
                  <ul>
                    <br />
                    <li className="nav-item">
                      <Link
                        style={footerText}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Documents and references"
                        to={"/landing/academy"}
                        className="nav-link"
                      >
                        Docs and Links
                      </Link>
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>

            <hr
              style={{
                borderColor: "#cccccc",
                width: "100%",
              }}
            />

            <Col sm={2} md={12} style={{ width: "100%" }}>
              <div style={{ paddingTop: "5px", paddingBottom: "10px" }}>
                <Row>
                  <div className="col-sm-3" style={{ textAlign: "left" }}>
                    <a
                      href="https://www.maersk.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src={maerskLogo}
                        alt="MaerskLogo"
                        height="50rem"
                        width="200rem"
                      />
                    </a>
                  </div>

                  <div
                    className="col-sm-9 float-right"
                    style={{ textAlign: "right" }}
                  >
                    <p style={{ color: "#cccccc", fontSize: "small" }}>
                      Find us on
                      <a
                        href="https://www.yammer.com/maerskgroup.com/#/threads/inGroup?type=in_group&feedId=10461175808&view=all"
                        title="Yammer"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#cccccc",
                          height: "20px",
                          width: "20px",
                        }}
                      >
                        {" "}
                        <FaYammer size={32} />
                      </a>
                      <a
                        href="https://teamsite.maerskgroup.com/teams/maestro/SitePages/Maestro-Core-Engineering.aspx"
                        title="Teamsite"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#cccccc",
                          height: "20px",
                          width: "20px",
                        }}
                      >
                        {" "}
                        <Image
                          src={sharepoint}
                          alt="Sharepoint"
                          height="35px"
                          width="35px"
                          style={{ position: "absolute" }}
                        />
                      </a>
                    </p>
                    <p
                      style={{
                        color: "#cccccc",
                        fontSize: "small",
                        lineHeight: "18px",
                      }}
                    >
                      Developed and Managed by Maestro Platform Capability Team.
                      <br />
                      Copyright ©{today.getFullYear()} Maersk. All Rights
                      Reserved.
                    </p>
                  </div>
                </Row>
              </div>
            </Col>
          </Col>
        </div>
      </footer>
    </div>
  );
};
export default FooterComponent;
